import { Helmet } from "react-helmet-async"
import { IHotel } from "../../../../Hotels"
import { HotelNotes } from "../../../../Hotels/Item"
import { useOutletContext } from "../../../../router-utils"

export default function HotelBasicDetailsPage() {
	const { hotel, revalidate } = useOutletContext<{
		hotel: IHotel
		revalidate: () => void
	}>()
	return (
		<>
			<Helmet>
				<title>Hotel Notes</title>
			</Helmet>
			<HotelNotes hotel={hotel} onChange={revalidate} />
		</>
	)
}
